import { render, staticRenderFns } from "./AddReviewForm.vue?vue&type=template&id=2d417dcd&"
import script from "./AddReviewForm.vue?vue&type=script&lang=js&"
export * from "./AddReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports